import styled from 'styled-components';
import { AppSelect } from '@/components/ui/AppSelect';

export const SelectWithExternalTags = styled(AppSelect)`
    .ant-select-selection-overflow-item:not(.ant-select-selection-overflow-item-suffix) {
        display: none;
    }
`;

export const SelectionSummary = styled.div`
    grid-column: 1 / -1;
    margin-bottom: 4px;
`;

export const SelectionChipWrap = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 8px;
`;

export const SelectionChip = styled.div`
    border: 1px solid rgba(138, 152, 167, 0.45);
    border-radius: 999px;
    padding: 5px 10px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: ${({ theme }) => theme.colors.background.secondary};

    &:hover button {
        opacity: 1;
        width: 18px;
    }
`;

export const SelectionChipRemoveButton = styled.button`
    border: none;
    background: transparent;
    cursor: pointer;
    opacity: 0;
    width: 0;
    overflow: hidden;
    transition: opacity 0.2s ease, width 0.2s ease;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.colors.text.secondary};
`;
